import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// $FlowFixMe
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import classes from 'app/pages/Admin/Offices/Offices.module.scss';
import ModalCreateOffice from 'app/pages/Admin/Offices/ModalCreateOffice';
import Office from 'app/pages/Admin/Offices/Office/Office';
import { Permission } from 'app/containers/Permissions/index.js';
import { MUIButton } from 'app/components/Form';
import { ModulableTree } from 'app/components/ModulableTree/ModulableTree.jsx';
import { labelFullWidth } from 'app/components/ModulableTree/styles';
import { ModalTrigger } from 'app/components/Modal';
import Widget from 'app/components/Widget/Widget.jsx';
import { fetchOffices } from 'app/store/reducers/offices';
import { sortedOfficesSelector } from 'app/store/selectors/offices';
import { colors } from 'app/styles/colors';
const Offices = () => {
    const { officeId } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const offices = useSelector(sortedOfficesSelector);
    useEffect(() => {
        dispatch(fetchOffices());
    }, []);
    const onSelectOffice = (office) => {
        history.push(`/admin/offices/${office.id}`);
    };
    return (_jsxs("div", { className: classes.container, children: [_jsx(Widget, { className: classes.groupListArea, style: { height: '100%', width: '100%' }, children: _jsx(ModulableTree, { title: "Offices", items: offices.map((office) => {
                        return {
                            classes: labelFullWidth,
                            noLevel: true,
                            key: office.name,
                            label: (_jsx("div", { onClick: () => onSelectOffice(office), className: classes.item, style: office.id === officeId
                                    ? { backgroundColor: colors.yuzuPrimaryColor, color: colors.yuzuBlack, fontWeight: 'bold' }
                                    : { cursor: 'pointer' }, children: office.name })),
                        };
                    }), Header: _jsx(Permission, { actions: ['projet_groups_group_create'], children: _jsx(ModalTrigger, { modal: _jsx(ModalCreateOffice, {}), children: _jsx(MUIButton, { dataCy: "create-office", icon: "fas-plus" }) }) }) }) }), _jsx(Switch, { children: _jsx(Route, { path: `/admin/offices/:officeId`, component: Office }) })] }));
};
export default Offices;
